import { Suspense } from "react";
import type { PropsWithChildren } from "react";

import { useIsMounted } from "../../utils/useIsMounted";
import { Loading } from "../Loading";

export const ClientSuspense = ({ children }: PropsWithChildren) => {
  const isMounted = useIsMounted();

  return isMounted ? (
    <Suspense fallback={<Loading />}>{children}</Suspense>
  ) : (
    <Loading />
  );
};
